import { jsx as _jsx } from "react/jsx-runtime";
import { I18nextProvider } from 'react-i18next';
import { i18n } from '@data/other/i18n';
export const withI18nProvider = (Component) => (props) => (_jsx(I18nextProvider, { i18n: i18n, children: _jsx(Component, Object.assign({}, props)) }));
